export const countryConstants = {
  SAUDIA_ARABIA: process.env.REACT_APP_Country_Id,
};

// using nationalityConstants because these will be very low in count
export const nationalityConstants = {
  SAUDIA_ARABIA: "Saudi Arabian",
};
